export default "__VITE_ASSET__2df9568e__"